import { Component, Injector, OnInit } from '@angular/core';
import { AuthorizationScheme, AuthorizationSchemeService, AutocompleteDataSourceFn, createDtoProperties, DtoComponent, FileUploadEvent, MgAutocompleteData } from '@mango/core';
import { Personeel } from '../core/dto/personeel';
import { BedrijfService } from '../core/service/bedrijf.service';
import { PersoneelService } from '../core/service/personeel.service';
import { setValue } from '../core/utils/form-helpers';
import { User } from './user';
import { UserService } from './user.service';


@Component({
    selector: 'ewp-user',
    templateUrl: './user.component.html',
    styleUrls: ['./user.component.css']
})
export class UserComponent extends DtoComponent<User> implements OnInit {
    properties = createDtoProperties<User>([
        { 'personeel': ['naam', 'voornaam', 'tussenvoegsel', 'achternaam', 'eMail'] },
        "firstName",
        "lastName",
        "email",
        "werkbonPrinter",
        "stickerPrinter",
        "pakbonPrinter",
        "factuurPrinter",
        "certificaatVoorbladPrinter",
        "certificaatVolgbladPrinter",
        "algemenePrinter",
        "hasRelaties",
        "meetInstrumenten",
        "energie",
        "certificaatSignatureName",
        "certificaatSignatureFile",
        "archivedOn",
        "locked",
        "lastPasswordChanged",
        "mfaEnabled",
        "isMfaExempt",
        "internalLogin"
    ]);

    getPersoneelDataSource: AutocompleteDataSourceFn<Personeel>;
    printers: string[];
    myScheme: AuthorizationScheme;

    constructor(private userService: UserService, injector: Injector, personeelService: PersoneelService, private bedrijfService: BedrijfService, private authService: AuthorizationSchemeService) {
        super(injector, userService, User);

        this.myScheme = this.authService.getMyScheme();

        if (this.isNewItem){
            this.getPersoneelDataSource = MgAutocompleteData.of<Personeel>(personeelService, personeelService.getActiefFilter(), 'naam', 'voornaam', 'tussenvoegsel', 'achternaam', 'eMail'); 
        } else {
            this.getPersoneelDataSource = MgAutocompleteData.of<Personeel>(personeelService, null, 'naam', 'voornaam', 'tussenvoegsel', 'achternaam', 'eMail'); 
        }
    }

    ngOnInit() {

        if (!this.CanShow("CIJBorculo.Logic.User")) {
            this.router.navigateByUrl('/dashboard');
        }
        
        super.ngOnInit();
        this.getPrinters();
        this._handleRoute();        
    }

    private _handleRoute() {
		this.handleRoute("id").subscribe(() => {
            if (this.isNewItem) {
                this.form.controls.meetInstrumenten.setValue(false);
                this.form.controls.meetInstrumenten.markAsDirty();
                this.form.controls.energie.setValue(false);
                this.form.controls.energie.markAsDirty();                
            }
            this.setCustomActions();
		});
    }

    personeelDisplayFn(personeel: Personeel) {
        return `${personeel.naam}`;
	}

    getPrinters() {
		this.bedrijfService.SelectPrinters().toPromise().then(
			a => {
				this.printers = a.printers;
			}
		);
		
	}

    canChangeUser() {
        return this.authScheme.canDo("Mango.Authentication.ActivationCodeRequest`1");
    }

    async onPersoneelSelected(personeel: Personeel) {

        // Alleen bij een nieuw item!
        if (this.isNewItem) {
            if (personeel != null) {
                setValue("firstName", personeel.voornaam, this.form);
                if (personeel.tussenvoegsel == null) {
                    setValue("lastName", personeel.achternaam, this.form);
                } else {
                    setValue("lastName", (personeel.tussenvoegsel + ' ' + personeel.achternaam).trim(), this.form);
                }
                
                setValue("email", personeel.eMail, this.form);
            }
        }
    }

    private setCustomActions() {
        this.buildCustomActions(config => config.add({
            icon: "lock_outline",
            name: "Stuur activatie code",
            fn: () => {
                this.dialogs.confirm("Stuur activatie code", `Hiermee stuurt u een activatie code naar ${this.item.firstName} ${this.item.lastName}, waarmee hij of zij het account kan activeren om vervolgens in te loggen.\n\nWeet u zeker dat u wilt doorgaan?`)
                    .then(ok => {
                        if (ok) {
                            this.userService.sendActivationCode(this.item.id).toPromise()
                                .then(ok => {
                                    if (ok && ok.successfull) {
                                        this.dialogs.alert("Verzonden", "De activatie code is verzonden.", "info_outline");
                                    }
                                    else {
                                        this.dialogs.alert("Fout", "Er is een fout opgetreden, probeer het later nog een keer.", "warning");
                                    }
                                });
                        }
                    });
            },
            show: () => !this.isNewItem && this.authScheme.canDo("Mango.Authentication.ActivationCodeRequest`1")
        }));
    }

    canDelete(){
        return false;
    }

    isArchived() {
        return (this.item.archivedOn != null);
    }

    onFileChanged(ev: FileUploadEvent) {   
            
        this.form.controls.certificaatSignatureFile.setValue(ev.data);
        this.form.controls.certificaatSignatureFile.markAsDirty();
    }	

    
    CanShow(type: string) {
        // User moet leesrechten omdat je de behandelaar moet kunnen selecteren
        // Alleen rechtstreeks via de url moet dit eigenlijk niet kunnen met alleen leesrechten.
        return this.myScheme.canRead(type) && (this.myScheme.canCreate(type) || this.myScheme.canUpdate(type) || this.myScheme.canDelete(type)) ;
    }

    CanRead(type: string) {
        return this.myScheme.canRead(type);
    }

    CanCreate(type: string) {
        return this.myScheme.canCreate(type);
    }

}
